import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { CheckBox } from "@/components/ui/CheckBox";
interface CheckboxGroupInputProps {
  label?: string;
  description?: string;
  options: string[];
  optionLabels?: string[];
  optionDescriptions?: string[];
  value: string[];
  onChange: (value: string[]) => void;
}
export default function CheckboxGroupInput(t0) {
  const $ = _c(24);
  const {
    label,
    description,
    options,
    optionLabels,
    optionDescriptions,
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] !== onChange || $[1] !== value) {
    t1 = option => {
      if (value.includes(option)) {
        onChange(value.filter(v => v !== option));
      } else {
        onChange([...value, option]);
      }
    };
    $[0] = onChange;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const toggle = t1;
  let t2;
  if ($[3] !== label) {
    t2 = label && <legend className="field-label">{label}</legend>;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== description) {
    t3 = description && <p className="text-ds-text-subtle dark:text-ds-text-disabled text-xs">{description}</p>;
    $[5] = description;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== optionDescriptions || $[8] !== optionLabels || $[9] !== options || $[10] !== toggle || $[11] !== value) {
    let t5;
    if ($[13] !== optionDescriptions || $[14] !== optionLabels || $[15] !== toggle || $[16] !== value) {
      t5 = (option_0, i) => {
        const checked = value.includes(option_0);
        return <label key={option_0} className={`flex w-full cursor-pointer items-center gap-3 px-3 py-2.5 text-left text-sm transition-colors ${checked ? "bg-blue-50 dark:bg-blue-900/20" : "bg-ds-surface-card hover:bg-ds-surface-hover dark:hover:bg-ds-neutral-800/50"}`}><CheckBox checked={checked} onChange={() => toggle(option_0)} size="sm" variant="brand" /><div className="min-w-0 select-none"><span className="text-ds-text-primary text-sm font-medium">{optionLabels?.[i] ?? option_0}</span>{optionDescriptions?.[i] && <p className="text-ds-text-muted text-xs">{optionDescriptions[i]}</p>}</div></label>;
      };
      $[13] = optionDescriptions;
      $[14] = optionLabels;
      $[15] = toggle;
      $[16] = value;
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    t4 = options.map(t5);
    $[7] = optionDescriptions;
    $[8] = optionLabels;
    $[9] = options;
    $[10] = toggle;
    $[11] = value;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[18] !== t4) {
    t5 = <div className="border-ds-neutral-300 dark:border-ds-neutral-700 divide-ds-neutral-300 dark:divide-ds-neutral-700 divide-y overflow-hidden rounded-lg border">{t4}</div>;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t2 || $[21] !== t3 || $[22] !== t5) {
    t6 = <fieldset className="space-y-2" role="group">{t2}{t3}{t5}</fieldset>;
    $[20] = t2;
    $[21] = t3;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
}